import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// 25s timeout — long enough for slow Gemini AI calls + R2 uploads, but won't
// let a request hang forever when the backend is dead (was: no timeout =
// infinite spinner on the login button during outages).
export const api = axios.create({ baseURL: API, timeout: 25000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mercy_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only auto-redirect to /login when the server explicitly says 401
    // (invalid/expired token). Don't act on network errors, 5xx, or
    // timeouts — those used to wipe sessions and force re-login during
    // a 10-second backend hiccup.
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("mercy_token");
        localStorage.removeItem("mercy_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
